import React from 'react'
import FulfillmentSummary from './fulfillmentSummary'
import { containerIprops } from './fullfilmentsummaryinterface'
import { operations as commondataoperations } from "../../../state/features/common/globaldata";
import { useDispatch } from "react-redux";

const FulfillmentSummarycontainer = (props: containerIprops) => {
   const dispatch = useDispatch();
   const dispatchsetGlobalData = commondataoperations.dispatchCurrentGlobalData(dispatch);

   const onMakeThisDefault = (data: any) => {
      const selectedBranch = {
         BranchCode: data?.branchCode,
         BranchName: data?.branchName,
         isAvailabilityRefresh: true
      }
       dispatchsetGlobalData(selectedBranch);
       props.shoppingcartOnClick();
   };

   return (
      <FulfillmentSummary
         availabilityDetails={props?.availabilityDetails}
         scrollToDiv={props?.scrollToDiv}
         onMakeThisDefault={onMakeThisDefault} />
   )
}

export default FulfillmentSummarycontainer